// extracted by mini-css-extract-plugin
module.exports = {"ready-icon":"CreatePurchaseRequestView_ready-icon__HFkLh","custom-fields-list":"CreatePurchaseRequestView_custom-fields-list__178I4"};